import React from "react";

const FlecheRightFaq = () =>{
    return(
        <>
            <svg className="FlecheRightFaq" width="83" height="84" viewBox="0 0 83 84" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g filter="url(#filter0_d_1201_6856)" style={{cursor:'pointer'}}>
                                                            <circle cx="41.6545" cy="37.1838" r="25.3309" fill="white"/>
                                                            </g>
                                                            <path d="M38.5448 45.4403L46.7641 37.1837L38.5448 28.9271" stroke="#4A3AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                            <defs>
                                                            <filter id="filter0_d_1201_6856" x="0.323608" y="0.852905" width="82.6617" height="82.6617" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                                            <feOffset dy="5"/>
                                                            <feGaussianBlur stdDeviation="8"/>
                                                            <feColorMatrix type="matrix" values="0 0 0 0 0.0323264 0 0 0 0 0.0598209 0 0 0 0 0.204167 0 0 0 0.06 0"/>
                                                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1201_6856"/>
                                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1201_6856" result="shape"/>
                                                            </filter>
                                                            </defs>
                                                                            </svg>
        </>
    )
}

export default FlecheRightFaq